import axios from 'axios';
import { message } from 'antd';
import apiUrl from 'helpers/apiUrl';

const getExpertArticles = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/expert-articles`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export const getExpertsAskArticles = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/expert-articles/ask-experts`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getExperts = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/expert-articles`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getRepresentatives = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/users/representatives`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export const getAdministrators = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/users/administrators`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getExpertArticlesCategories = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/expert-articles/categories`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getExpertArticleById = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/expert-articles/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export const getAskExpertArticleById = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/expert-articles/ask-experts/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const getExpertArticlesCategoryById = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/expert-articles/categories/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const removeExpertArticleById = async (idNews: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/expert-articles/${idNews}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      return true;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

export const removeAskExpertsById = async (idNews: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios.delete(`${apiUrl()}backoffice/expert-articles/ask-experts/${idNews}`, {
    headers: {
      Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
    },
  });
};

const removeExpertArticlesCategoryById = async (id: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/expert-articles/categories/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      return true;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const createExpertArticle = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/expert-articles`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response.data?.error === 'DUPLICATE') {
        message.error('Wpis o danym tytule już istnieje');
      } else {
        message.success('Pozytywnie utworzono poradę ekspertów');
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export const createAskExpertArticle = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/expert-articles/ask-experts`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response.data?.error === 'DUPLICATE') {
        message.error('Wpis o danym tytule już istnieje');
      } else {
        message.success('Pozytywnie utworzono poradę ekspertów');
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const createExpertArticlesCategory = async (data: {
  isActive?: boolean;
  name: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/expert-articles/categories`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      message.success('Pozytywnie utworzono kategorię porady');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const deleteExpertArticlesCategoryCache = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/expert-articles/categories/cache`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const deleteExpertArticlesCache = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/expert-articles/cache`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const saveExpertArticle = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/expert-articles/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export const saveAskExpertArticle = async (data: {
  id: number;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/expert-articles/ask-experts/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const saveExpertArticlesCategory = async (data: {
  id: number;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/expert-articles/categories/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export {
  saveExpertArticle,
  getExpertArticleById,
  getExpertArticles,
  removeExpertArticleById,
  createExpertArticle,
  getExpertArticlesCategories,
  removeExpertArticlesCategoryById,
  getExpertArticlesCategoryById,
  createExpertArticlesCategory,
  saveExpertArticlesCategory,
  deleteExpertArticlesCategoryCache,
  deleteExpertArticlesCache,
  getRepresentatives,
  getExperts,
};
